import './instrument';
import 'react-app-polyfill/ie11';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './rightBanner';

ReactDOM.render(<App />, document.getElementById('root'));
